import { render } from "./SupportAuditList.vue?vue&type=template&id=0a32003e"
import script from "./SupportAuditList.vue?vue&type=script&lang=js"
export * from "./SupportAuditList.vue?vue&type=script&lang=js"

import "./SupportAuditList.vue?vue&type=style&index=0&id=0a32003e&lang=css"

import exportComponent from "/Users/admin/Desktop/bos-vue/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__